export default "__VITE_PUBLIC_ASSET__1e485a1d__"